import { DEFAULT_ICON_SIZE } from '../const';
import { IconProps } from '../types';

export const MicOffIcon = ({ size = DEFAULT_ICON_SIZE }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
      <path d="M15 9V4a3 3 0 0 0-5.94-.6" />
      <path d="M19 10v2a7 7 0 0 1-2.12 5" />
      <path d="M5 10v2a7 7 0 0 0 7 7" />
      <path d="M12 19v4" />
      <path d="M8 23h8" />
      <path d="M2 2l20 20" />
    </svg>
  );
};

